import { render, staticRenderFns } from "./BrowserStat.vue?vue&type=template&id=3cb2d073&scoped=true&"
import script from "./BrowserStat.vue?vue&type=script&lang=js&"
export * from "./BrowserStat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb2d073",
  null
  
)

export default component.exports